import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ErrorPanel from '../components/ErrorPanel';
import { trackPage } from '../../lib/analytics-helper';
import IcfArticlesContainer from './IcfArticlesContainer';
import IcfTopicContainer from './IcfTopicContainer';
import UrlResources from '../constants/UrlResources';

class icfContainer extends Component {
  icfPageResponse() {
    const pathName = this.props.location && this.props.location.pathname;
    // icf articles url condition
    const icfArticles = this.props.icfId && (pathName.indexOf(`${this.props.icfId.toLowerCase()}`) >= 0
      || pathName.indexOf(this.props.icfId.toUpperCase()) >= 0);
    // icf topics
    const icfTopic = pathName.indexOf(`/${UrlResources.PAYPALGUIDE}`) >= 0 && !icfArticles;
    // remote config
    if (!this.props.blacklistedMarketICFFlag) {
      if (icfArticles) {
        // When clicking on icf guide/icf topic return icfArticle page
        return (
          <IcfArticlesContainer />
        );
      } if (icfTopic) {
        // when clicking on paypal help guide L1 topic return icf topic page
        return (
          <IcfTopicContainer />
        );
      }
    } else {
      if (icfTopic) {
        // ICF Topic Page Error
        trackPage({ id: 'ICFTopicPageError', link: 'smarthelp-error-country-not-enabled' });
      } else if (icfArticles) {
        // ICF Articles Page Error
        trackPage({ id: 'ICFPageError', link: 'smarthelp-error-country-not-enabled', hpid: this.props.icfId });
      }
      return <ErrorPanel pageName="icfErrorPage" />;
    }
    return null;
  }

  render() {
    return this.icfPageResponse();
  }
}

icfContainer.propTypes = {
  location: PropTypes.string.isRequired,
  icfId: PropTypes.string.isRequired,
  blacklistedMarketICFFlag: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    location: state.location,
    icfId: state.icfPage.currentIcfId,
    blacklistedMarketICFFlag: state.topicList.blacklistedMarketICFFlag,
  };
}

export default connect(mapStateToProps)(icfContainer);
